export default __webpack_public_path__ + "static/media/teammember-about.44053a41.png";